import { inject, Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { mergeMap, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { ReportsResultsHttpClient } from './results.http-client';
import { ReportsResultsActions } from './results.store';

@Injectable()
export class ReportsResultsEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(ReportsResultsHttpClient);

  public effects = createEffectFactory(ReportsResultsActions, this.actions$);

  public fetchVisualization$ = this.effects(
    ReportsResultsActions.fetchOneResult,
    ({ payload }) =>
      this.http.load(payload.data.kind, payload.data.params).pipe(
        map(response =>
          ReportsResultsActions.fetchOneResultSuccess({
            payload: {
              correlationId: payload.data.paramsHash,
              data: {
                paramsHash: payload.data.paramsHash,
                response,
              },
            },
          }),
        ),
        catchError(err =>
          of(
            ReportsResultsActions.fetchOneResultFailed({
              payload: {
                correlationId: payload.data.paramsHash,
                data: {
                  paramsHash: payload.data.paramsHash,
                  error: {
                    status: err.status,
                    message: err.message,
                  },
                },
              },
            }),
          ),
        ),
      ),
    { customMapOperator: mergeMap },
  );
}
